import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "question-filter-select",
  id: "question-filter-select"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "标签集", -1)
const _hoisted_3 = { class: "labelSets" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = {
  key: 0,
  class: "label-item-list"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "title" }, "选中标签集", -1)
const _hoisted_8 = { class: "labels-selected" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.checkList,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkList = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketLabelSetList, (s) => {
              return (_openBlock(), _createBlock("div", {
                class: "labelSet",
                key: s.id
              }, [
                _createVNode(_component_el_checkbox, {
                  label: s.id
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["label"]),
                _createVNode(_component_el_card, {
                  class: "box-card",
                  shadow: "never"
                }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("span", null, _toDisplayString(s.labelSetName), 1),
                      _createVNode("i", {
                        class: ["icon-arrow-grey", {
                  up: s.showLabeItemlList
                }],
                        onClick: ($event: any) => (s.showLabeItemlList = !s.showLabeItemlList)
                      }, null, 10, ["onClick"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (s.showLabeItemlList)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(s.labels, (l) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "label-item",
                              label: l.id,
                              key: l.id
                            }, _toDisplayString(l.name), 9, ["label"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode("div", null, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketLabelSetListSelected, (s, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "labelSet",
              key: s.id
            }, [
              _createVNode(_component_el_card, {
                class: "box-card",
                shadow: "never"
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", null, _toDisplayString(s.labelSetName), 1)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode("i", {
                onClick: ($event: any) => (_ctx.checkList.splice(i, 1)),
                style: {"margin":"9px","cursor":"pointer"},
                class: "el-icon-close"
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(_ctx.ticketLabelSetListSelected.slice()))),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ])
  ]))
}